// extracted by mini-css-extract-plugin
export default {"streamDetail":"YveZ8","checkmark":"XIJKX"};